export const RotatedTick = ({ x, y, payload, fill }: any) => {
  return (
    <text
      x={x}
      y={y}
      dy={10}
      textAnchor="end"
      transform={`rotate(-90, ${x}, ${y})`}
      fill={fill}
      style={{ fontSize: 12 }}
    >
      {payload.value}
    </text>
  );
};
